import { A02 } from 'api/U011';

export interface DeleteResult {
  status: string;
  count: number;
  msg: string;
}

export const putMessages = async (userId: string, auditionId: string) => {
  if (!userId || !auditionId) {
    return;
  }
  try {
    const json = await A02(userId, auditionId);
    return {
      status: '00',
      count: json.count,
      msg: '',
    } as DeleteResult;
  } catch (err: unknown) {
    console.error(err);
    return {
      status: '99',
      count: 0,
      msg: err instanceof Error ? err.message : err,
    } as DeleteResult;
  }
};
